import { atom } from "jotai";

export const allocatedRoomBarIsOpenAtom = atom<boolean | undefined>(undefined);
